module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0005_001",
      "id": "d14e107",
      "src": "images/AtomicRanchBook_0005_001.jpg"
    }
  })]), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2185"
    }
  }, [_c('b', [_vm._v("Contents ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2235"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c16_r1#d7e1",
      "id": "d6e1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2265"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c17_r1#d7e2",
      "id": "d6e2"
    }
  }, [_vm._v("Inspiring Originals")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2295"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c18_r1#d7e3",
      "id": "d6e3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is My House a Ranch?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2345"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c19_r1#d7e4",
      "id": "d6e4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stunning Transformations")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2375"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c20_r1#d7e5",
      "id": "d6e5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modest Makeovers")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2425"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c21_r1#d7e6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pure Fun")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2465"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c22_r1#d7e7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outside the Ranch")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2495"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c23_r1#d7e8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adding Personality")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2525"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c24_r1#d7e9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preserving Midcentury Neighborhoods")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2575"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Grin_ISBN9781423600022_epub_c25_r1#d7e10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ranch Resources")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e31b8d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grin_ISBN9781423600022_epub_c15_r1.vue
// module id = 72
// module chunks = 0